document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header], .site-header');
  const toggle = document.querySelector('[data-menu-toggle]');
  const panel = document.querySelector('[data-mobile-panel]');
  const cursor = document.querySelector('.cursor-orbit');
  let lastY = window.scrollY;
  let ticking = false;

  const updateHeader = () => {
    const currentY = Math.max(window.scrollY, 0);
    const scrollingDown = currentY > lastY + 6;
    const scrollingUp = currentY < lastY - 6;
    header?.classList.toggle('is-scrolled', currentY > 24);
    if (currentY > 170 && scrollingDown && !panel?.classList.contains('is-open')) header?.classList.add('is-hidden');
    if (scrollingUp || currentY < 170) header?.classList.remove('is-hidden');
    lastY = currentY;
    ticking = false;
  };

  updateHeader();
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });

  toggle?.addEventListener('click', () => {
    const open = panel.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
    panel.setAttribute('aria-hidden', String(!open));
    header?.classList.remove('is-hidden');
    document.body.style.overflow = open ? 'hidden' : '';
  });

  document.querySelectorAll('[data-mobile-panel] a').forEach((link) => link.addEventListener('click', () => {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    toggle?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }));

  const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }
  }), { threshold: .14, rootMargin: '0px 0px -6%' });
  document.querySelectorAll('.reveal,.media-reveal').forEach((element) => observer.observe(element));

  if (matchMedia('(pointer:fine)').matches && cursor) {
    window.addEventListener('mousemove', (event) => {
      cursor.style.left = `${event.clientX}px`;
      cursor.style.top = `${event.clientY}px`;
      cursor.classList.add('is-active');
    });
    document.querySelectorAll('a,button,summary,select').forEach((element) => {
      element.addEventListener('mouseenter', () => cursor.classList.add('is-link'));
      element.addEventListener('mouseleave', () => cursor.classList.remove('is-link'));
    });
  }

  document.querySelectorAll('[data-quantity]').forEach((input) => input.addEventListener('change', () => {
    if (Number(input.value) < 1) input.value = 1;
  }));
});
